import axios from 'axios'

const util = require('../../util.js')

const default_filter = {
  orderStatus: null,
  orderId: null,
  source: null,
  customer: null,
  buyer: null,
  fromDate: null,
  toDate: null
}

const default_paging = {
  currentPage: 1,
  perPage: 25,
  perPageAlternatives: [25, 50, 100],
  totalRows: 0
}

const state = {
  order: {
    'orderId': undefined,
    'orderStatus': undefined,
    'orderSource': undefined,
    'orderSourceId': undefined,
    'buyerId': undefined,
    'buyerAcoId': undefined,
    'buyerContactName': undefined,
    'buyerContactEmail': undefined,
    'buyerOrganizationNumber': undefined,
    'buyerOrganizationName': undefined,
    'buyerOrderId': undefined,
    'customerAcoId': undefined,
    'customerContactName': undefined,
    'customerContactEmail': undefined,
    'customerReference': undefined,
    'customerOrganizationNumber': undefined,
    'customerOrganizationName': undefined,
    'customerUserId': undefined,
    'orderCurrency': undefined,
    'orderTotalAmount': undefined,
    'orderPayment': undefined,
    'orderLines': [
      {
        'sourceLineId': undefined,
        'status': undefined,
        'statusDescription': undefined,
        'productSource': undefined,
        'productSourceId': undefined,
        'productEan': undefined,
        'productName': undefined,
        'productType': undefined,
        'productPrice': undefined,
        'productTaxRate': undefined,
        'flatDiscountPercent': undefined,
        'quantity': undefined,
        'validFrom': undefined,
        'validTo': undefined,
        'includeInInvoice': undefined,
        'totalAmount': undefined
      }
    ],
    'created': undefined,
    'modified': undefined
  },
  orders: [],
  filter: { ...default_filter },
  paging: { ...default_paging },
  events: [],
  isShowEventButtonEnabled: true,
  loading:  false
}

const mutations = {
  UPDATE_ORDER (state, payload) {
    state.order = payload
  },
  UPDATE_ORDERS (state, payload) {
    state.orders = payload.response
    state.paging.totalRows = payload.resultCount
  },
  UPDATE_FILTER (state, payload) {
    state.filter = payload
  },
  UPDATE_PAGING (state, payload) {
    state.paging = payload
  },
  UPDATE_ORGANIZATION_NUMBER(state, payload){
    state.filter.customer =  payload
  },
  UPDATE_EVENTS ( state, payload ){
    state.events = payload
    state.isShowEventButtonEnabled = false
  },
  UPDATE_EMPTY_EVENT ( state ) {
    state.events = null
    state.isShowEventButtonEnabled = true
  },
  UPDATE_FORM_DISABLE_INDICATOR (state, payload) {
    state.loading = payload
  }
}

const actions = {
  async getOrders ({ commit, dispatch }) {
    commit('UPDATE_FORM_DISABLE_INDICATOR', true)
    await dispatch('getSelectedActiveProfile')
    axios.get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/order/', {
      params: {
        status: util.emptyToNull(state.filter.orderStatus),
        orderId: util.emptyToNull(state.filter.orderId),
        source: util.emptyToNull(state.filter.source),
        buyer: util.emptyToNull(state.filter.buyer),
        customer: util.emptyToNull(state.filter.customer),
        createdFrom: util.dateToTimestamp(state.filter.fromDate),
        createdTo: util.dateToTimestamp(state.filter.toDate),
        pageNumber: util.emptyToNull(state.paging.currentPage),
        pageSize: util.emptyToNull(state.paging.perPage)
      }
    }).then((response) => {
      commit('UPDATE_ORDERS', response.data)
    }).finally(() => {
      commit('UPDATE_FORM_DISABLE_INDICATOR', false)
    })
  },
  getOrder ({ commit }, orderId) {
    axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/order/' + orderId)
      .then((response) => {
        // Add _showDetails for rows with statusDescription so Vue will show row details slot for these
        if (response.data.orderLines) {
          response.data.orderLines.forEach(item => {
            if (item.statusDescription) {
              item._showDetails = true
            }
          })
        }
        commit('UPDATE_ORDER', response.data)
      })
  },
  async updateOrderLineStatus ({ dispatch }, request) {
    await axios
      .patch(process.env.VUE_APP_INTERNAL_API_BASEURL + '/order/' + request.orderId + '/' + request.orderLineId,
        {
          comment: request.updateRequest.description ? request.updateRequest.description : null,
          status: request.updateRequest.status ? request.updateRequest.status : null
        })
    dispatch('getOrder', request.orderId)
  },
  async updateCustomerEmail ({ dispatch }, request) {
    await axios
      .patch(process.env.VUE_APP_INTERNAL_API_BASEURL + '/order/' + request.orderId,
        {
          email: request.updateRequest.customerEmail,
      })
    dispatch('getOrder', request.orderId)
  },
  resetFilter ({ commit }) {
    commit('UPDATE_PAGING', { ...default_paging })
    commit('UPDATE_FILTER', { ...default_filter })
  },
  updateOrganization({commit} , orgNumber ) {
    commit('UPDATE_ORGANIZATION_NUMBER' , orgNumber)
  },
  getObjectReference ({ dispatch, commit }, objectReference) {
    return dispatch('events/getObjectReference', { objectReference: objectReference }, { root: true })
      .then((response) => {
          if(response.length > 0){
            commit('UPDATE_EVENTS', response )
          }else {
            commit('UPDATE_EMPTY_EVENT')
          }
        }
      )},
  getSelectedActiveProfile ({ commit, rootGetters }) {
    let isActiveProfileSelected = rootGetters['sessionStorage/isActiveProfileSet']
    if(isActiveProfileSelected) {
      let activeProfile = rootGetters['sessionStorage/activeProfile']
      if(activeProfile != null) {
        commit('UPDATE_ORGANIZATION_NUMBER', activeProfile.id)
      }
    }
  }
}

const getters = {
  order: state => state.order,
  orders: state => state.orders,
  filter: state => state.filter,
  paging: state => state.paging,
  events: state => state.events,
  isShowEventButtonEnabled: state => state.isShowEventButtonEnabled,
  loading: state => state.loading
}

const ordersModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default ordersModule
